import { createEvent, createStore } from 'effector';
import { useUnit } from 'effector-react';

import { Permission } from './constants';

export const setPermissions = createEvent<Permission[]>('SET_PERMISSIONS');
export const $permissions = createStore<Permission[] | null>(null).on(setPermissions, (_, p) => p);

export const usePermissions = () => useUnit($permissions);

export const setAuthenticatedUser = createEvent<string | null>('SET_AUTHENTIATED_USER');
export const $authenticatedUser = createStore<string | null>(null).on(setAuthenticatedUser, (_, u) => u);

export const useAuthenticatedUser = () => useUnit($authenticatedUser);
